import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/prototypes/emails")({
  validateSearch: (search: Record<string, unknown>) => ({
    thread: typeof search.thread === "string" ? search.thread : undefined,
  }),
});
